import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_259: DocMigration = {
  maxSchemaVersion: "0.0.259",
  description: "Adds a default roofSideOverrides to each roof",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      roofs[id] = {
        ...roof,
        roofSideOverrides: {
          LEFT: roof.roofSideOverrides?.LEFT || {},
          RIGHT: roof.roofSideOverrides?.RIGHT || {},
          START: roof.roofSideOverrides?.START || {},
          END: roof.roofSideOverrides?.END || {},
        },
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_259;
